



















































import { Component, Prop, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'

@Component
export default class VarietyHeader extends Vue {
  @Prop() private varietyName!: any
}
